import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import {
  sendRequest,
  selectItemsIds,
  selectItemById
} from 'mt-react-common/common/reducers/list/reducer';

import MediumPreLoader from 'components/Common/PreLoaders/MediumPreLoader';

import RightSidebarMenuItem from './RightSidebarMenuItem';

const faqContentsMenuList = 'faqContents.lists.faqContentsMenuList';

class RightSidebar extends Component {
  constructor(props) {
    super(props);
    props.sendRequest();
  }

  render() {
    if (this.props.selectItemsIds.length === 0) {
      return <MediumPreLoader />;
    }
    return (
      <div className="page-sidebar-sticky">
        <div
          aria-multiselectable="true"
          className="panel-group panel-group-side"
          id="panelGroupFilter"
          role="tablist"
        >
          {this.props.selectItemsIds.map(itemId => (
            <RightSidebarMenuItem
              key={`rightSidebarMenuItem${itemId}`}
              item={this.props.selectItemById(itemId)}
            />
          ))}
        </div>
      </div>
    );
  }
}

RightSidebar.propTypes = {
  selectItemsIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  selectItemById: PropTypes.func.isRequired,
  sendRequest: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  selectItemsIds: selectItemsIds(state, faqContentsMenuList),
  selectItemById: id => selectItemById(state, faqContentsMenuList, id)
});

const mapDispatchToProps = dispatch => ({
  sendRequest: () => dispatch(sendRequest(faqContentsMenuList))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RightSidebar);



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/Help/ReferenceInformation/RightSidebar/RightSidebar.js